import React, { FC, useState, FormEvent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Input from "../UI/Input";
import Button from "../UI/Button";
import { signIn, setError } from "../../store/actions/userActions";
import { RootState } from "../../store";

import queryString from "query-string";

import ImgLogin from "../../assets/images/login/login.png";
import logo from "../../assets/images/successware.png";

import "../css/signin.css";

import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";

import GoogleAnalyticsConfiguration from "../../googleAnalytics/googleAnalyticsConfiguration";

const SignIn: FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [masterId, setMasterId] = useState("");
  const [agentName, setAgentName] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { error } = useSelector((state: RootState) => state.auth);
  const [handleMessage, setHandleMessage] = useState(false);

  useEffect(() => {
    GoogleAnalyticsConfiguration.sendPageView("Login");
    const loginCredentials = queryString.parse(window.location.search);
    if (window.location.search) {
      localStorage.setItem("masterID", loginCredentials.masterID as string);
      localStorage.setItem("agentName", loginCredentials.agentName as string);
      setMasterId(loginCredentials.masterID as string);
      setAgentName(loginCredentials.agentName as string);
    }
    if (error) showNotification("Login", error, "danger");
    return () => {
      if (error) {
        dispatch(setError(""));
      }
    };
  }, [error, dispatch]);

  const submitHandler = (e: FormEvent) => {
    e.preventDefault();
    if (error) {
      dispatch(setError(""));
    }
    setLoading(true);
    dispatch(
      signIn({ username, password, masterId, agentName }, () =>
        setLoading(false)
      )
    );
  };

  const showNotification = (title: string, message: string, type: any) => {
    store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    setHandleMessage(false);
  };

  return (
    <>
      <ReactNotification />

      <section
        className=" max-w-full-xl	 flex flex-col xl:flex-row xl:justify-center h-screen"
        style={{ backgroundImage: `url(${ImgLogin})` }}
      >
        <div className="mt-5 flex-1 flex items-center justify-center md:items-stretch xl:hidden ">
          <div className="flex-shrink-0 flex items-center">
            <img
              className="block lg:hidden h-8 w-auto"
              src={logo}
              alt="Workflow"
            />
            <img
              className="hidden lg:block h-8 w-auto"
              src={logo}
              alt="Workflow"
            />
          </div>
        </div>
        <div className="xl:hidden   mx-auto xl:mx-0  mt-14  px-5  rounded shadow-xl xl:w-full  ">
          <img
            className="hidden xl:block h-8 w-auto mb-4"
            src={logo}
            alt="successware logo"
          />
          <h1 className="hello-there mt-20">Hello There,</h1>
          <p className="welcome-success-p mt-6 xl:mt-2">
            Welcome to the Success Portal
          </p>
          <p className="we-cant-message xl:hidden">
            We can't wait to get you started filling your Dispatch board with new appointments.
          </p>
        </div>
        <div className="hidden xl:block  welcome-left mx-auto xl:mx-0  mt-14  px-5  rounded shadow-xl xl:w-full 3xl:mt-36">
          <img
            className="hidden xl:block h-8 w-auto mb-4"
            src={logo}
            alt="successware logo"
          />
          <h1 className="hello-there mt-20">Hello There,</h1>
          <p className="welcome-success-p mt-6 xl:mt-2">
            Welcome to the Success Portal
          </p>
          <p className="we-cant-message xl:hidden">
            We can't wait to get you started filling your Dispatch board with new appointments.{" "}
          </p>
          <p className="we-cant-message hidden xl:block">
            We can't wait to get you started filling your Dispatch board with new appointments.{" "}
          </p>
        </div>
        <div className=" max-w-screen-xl 3xl:max-w-screen-3xl   mt-10 xl:mt-0  bg-no-repeat bg-center xl:bg-right bg-img-blue md:bg-img-blue-md 3xl:bg-img-blue-lg xl:bg-img-blue-md  h-screen xl:h-screen xl:w-3/4 xl:absolute xl:ml-96">
          <div className="flex justify-end mr-6 flex-col pt-10 xl:pl-8 md:pr-14 md:mt-28 ">
            <p className="signin-p flex justify-end ">Sign In</p>
            <p className="please-enter-p xl:hidden">
              Please enter your username and password to access your account and start creating your new widget
            </p>
            <p className="please-enter-p hidden xl:block">
              Please enter your username and password to access your account{" "} and start creating your new widget
            </p>

            <form
              className="flex  justify-center flex-col mt-10"
              onSubmit={submitHandler}
            >
              <Input
                type="text"
                name="usename"
                value={username}
                onChange={(e) => setUsername(e.currentTarget.value)}
                placeholder="Username"
                label="User Name"
              />
              <Input
                type="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
                placeholder="Password"
                label="Password"
              />
              <Button
                text={loading ? "Loading..." : "LOGIN"}
                className=" text-white text-center w-full md:w-1/4  custom-btn-add-service login-button-margin"
                disabled={loading}
              />
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignIn;
